import type { IconData } from '@stacksjs/iconify-core'

export const playListFolderSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M18.996 4.242c-1.504-1.745-3.754-2.736-6.1-2.55c-2.985.238-5.12.56-6.606.86c-2.39.483-3.989 2.402-4.235 4.74C1.79 9.818 1.5 14.31 1.5 21.919s.289 12.1.555 14.628c.246 2.336 1.842 4.255 4.234 4.738c5.504 1.112 11.242 1.22 16.835 1.215a9 9 0 0 1 7.597-10.41l-.219-5.468l-.002-.12c0-3.257 2.903-5.851 6.045-5.463c3.4.42 5.983 1.788 7.942 3.554q.013-1.268.013-2.674c0-2.987-.044-5.494-.115-7.588c-.133-3.97-3.436-6.967-7.327-6.967H22.833a2.5 2.5 0 0 1-1.894-.868zm17.182 19.773c-1.308-.161-2.678.986-2.678 2.486l.352 8.79A6 6 0 1 0 38 41l.386-9.885c0-.504.434-.884.892-.746c1.973.595 4.318 1.918 6.44 4.736c.51.678 1.48.298 1.246-.533c-1.115-3.946-3.91-9.708-10.786-10.557\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default playListFolderSolid
